<template>
  <div id="keymapItem" class="has-text-centered">
    <button class="button is-small is-outline" @click="buttonClicked" :disabled="!enabled">
      {{from}}<br/>
      <strong>{{to}}</strong>
    </button>
  </div>
</template>

<script>
export default {
  name: "keymapItem",
  props: ["from", "to", "name", "enabled"],
  methods: {
    buttonClicked: function() {
      this.$emit("charClicked", this.to);
    }
  }
};
</script>

<style scoped>
.button {
  height: initial;
  display: initial;
}
</style>



// WEBPACK FOOTER //
// app/translit/src/components/keymapItem.vue